module.exports = __webpack_public_path__ + "img/stock4.8b074ea9.png";